import getPathToBecomeAdjacent from './getPathToBecomeAdjacent/index.js';
export function getPathToApproach(agentUnit, enemyUnit, hexProperties, rules, allUnits, mapHexes, terrainPreferences) {
    return getPathToBecomeAdjacent(agentUnit, enemyUnit, hexProperties, rules, allUnits, mapHexes, terrainPreferences, false);
}
export default getPathToApproach;
